import { __assign, __rest } from "tslib";
import React from 'react';
import { AnimatedPanel } from './AnimatedPanel';
import style from './SlidingPanel.scss';
import { getCoupledAnimationTimeouts } from './helpers';
// synced with SlidingPanel.scss
var TRANSITION_DURATION = 420;
var ENTER_TRANSITION_DELAY = 210;
var DEFAULT_TIMEOUT = getCoupledAnimationTimeouts(TRANSITION_DURATION, ENTER_TRANSITION_DELAY);
export var SlidingPanel = function (props) {
    var _a = props.timeout, timeout = _a === void 0 ? DEFAULT_TIMEOUT : _a, restProps = __rest(props, ["timeout"]);
    return (React.createElement(AnimatedPanel, __assign({}, restProps, { timeout: timeout, transitionClasses: {
            next: {
                enter: style.slideRightEnter,
                enterActive: style.slideRightEnterActive,
                exit: style.slideRightExit,
                exitActive: style.slideRightExitActive,
            },
            previous: {
                enter: style.slideLeftEnter,
                enterActive: style.slideLeftEnterActive,
                exit: style.slideLeftExit,
                exitActive: style.slideLeftExitActive,
            },
        } })));
};
SlidingPanel.displayName = 'SlidingPanel';
//# sourceMappingURL=SlidingPanel.js.map